import type { UseFormReturn } from "react-hook-form";

export const extractFormState = (
  form: UseFormReturn<{
    terms: boolean;
    phoneNumber: string;
    debtorCorpExternalId: string;
    externalId: string;
    bank: string;
    hb: string;
    reikn: string;
  }>
): {
  terms: boolean;
  phoneNumber: string;
  externalId: string;
  debtorCorpExternalId: string;
  bank: string;
  hb: string;
  reikn: string;
  bban: string;
} => {
  const terms = form.getValues("terms");
  const phoneNumber = form.getValues("phoneNumber");
  const externalId = form.getValues("externalId");
  const debtorCorpExternalId = form.getValues("debtorCorpExternalId");
  const bank = form.getValues("bank");
  const hb = form.getValues("hb");
  const reikn = form.getValues("reikn");
  const bban = `${bank.padStart(4, "0")}${hb}${reikn.padStart(6, "0")}`;

  return {
    terms: terms,
    phoneNumber: `+354${phoneNumber}`,
    externalId,
    debtorCorpExternalId,
    bank,
    hb,
    reikn,
    bban,
  };
};
